import React, { useState, useRef } from 'react';

/**
 * SimpleRichTextEditor - Fallback rich text editor when ReactQuill fails
 * Provides basic formatting with HTML generation
 */

const SimpleRichTextEditor = ({ value, onChange, placeholder }) => {
  const textareaRef = useRef(null);

  const insertFormatting = (before, after = '') => {
    const textarea = textareaRef.current;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = value.substring(start, end);
    const newText = value.substring(0, start) + before + selectedText + after + value.substring(end);
    
    onChange(newText);
    
    // Restore cursor position
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + before.length, end + before.length);
    }, 0);
  };

  const handleBold = () => insertFormatting('<strong>', '</strong>');
  const handleItalic = () => insertFormatting('<em>', '</em>');
  const handleBulletList = () => {
    const lines = value.split('\n');
    const currentLineIndex = textareaRef.current.value.substr(0, textareaRef.current.selectionStart).split('\n').length - 1;
    lines[currentLineIndex] = '• ' + lines[currentLineIndex];
    onChange(lines.join('\n'));
  };

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden bg-white">
      {/* Toolbar */}
      <div className="bg-gray-50 border-b border-gray-300 p-2 flex gap-2">
        <button
          type="button"
          onClick={handleBold}
          className="px-3 py-1 bg-white border border-gray-300 rounded hover:bg-gray-100 font-bold"
          title="Bold"
        >
          B
        </button>
        <button
          type="button"
          onClick={handleItalic}
          className="px-3 py-1 bg-white border border-gray-300 rounded hover:bg-gray-100 italic"
          title="Italic"
        >
          I
        </button>
        <button
          type="button"
          onClick={handleBulletList}
          className="px-3 py-1 bg-white border border-gray-300 rounded hover:bg-gray-100"
          title="Bullet List"
        >
          • List
        </button>
        <div className="flex-1"></div>
        <span className="text-xs text-gray-500 self-center">💡 Use HTML tags for formatting</span>
      </div>

      {/* Textarea */}
      <textarea
        ref={textareaRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full p-4 resize-none focus:outline-none"
        rows={10}
        style={{ minHeight: '200px' }}
      />

      {/* Help Text */}
      <div className="bg-gray-50 border-t border-gray-300 p-2 text-xs text-gray-600">
        <p><strong>HTML formatting supported:</strong> &lt;strong&gt;bold&lt;/strong&gt;, &lt;em&gt;italic&lt;/em&gt;, &lt;ul&gt;&lt;li&gt;list&lt;/li&gt;&lt;/ul&gt;</p>
        <p className="mt-1">Use emojis directly: 🎉🐾✨</p>
      </div>
    </div>
  );
};

export default SimpleRichTextEditor;
